import './assets/css/main.css'
import './assets/css/custom.css'
import'vant/lib/index.css'
import './assets/css/desktop.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import Root from './Root.vue'
import router from './router'
import vant from 'vant';
// default-passive-events 是一个轻量级的JavaScript库，
// 它通过自动为支持EventListenerOptions的浏览器设置事件监听器的{passive: true}选项，
// 帮助开发者优化页面的滚动性能。这个小巧的库仅50行代码，却能为你的项目带来显著的性能提升。
import 'default-passive-events'

const app = createApp(Root)

app.use(createPinia())
app.use(vant);
app.use(router)

// 将 router 添加到全局属性中
window.globalRouter = router;

app.mount('#app')

// 禁止页面空白处双击事件，导致页面上下移动的问题
document.addEventListener('dblclick', function (e) {
    e.preventDefault(); // 阻止双击默认行为
}, {
    passive: false
});
